import { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useIsF1User = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const readPermissionSelf: UserPermission = {
    resource: 'appaccess',
    action: 'readbasic',
    scope: 'self',
  };

  const canReadSelf = useHasPermission(user, readPermissionSelf);
  return canReadSelf;
};
